import React, { ReactNode } from "react";
import styled from "styled-components";

type FlexDirectionType = "row" | "column";
type FlexJustifyContent =
	| "flex-start"
	| "flex-end"
	| "center"
	| "space-between"
	| "space-around"
	| "space-evenly";

type flexAlignItems =
	| "center"
	| "flex-end"
	| "flex-start"
	| "space-between"
	| "space-around"
	| "space-evenly";

type FlexWrap = "wrap" | "no-wrap" | "wrap-reverse";
export interface FlexProps {
	direction?: FlexDirectionType;
	justifyContent?: FlexJustifyContent;
	alignItems?: flexAlignItems;
	margin?: string;
	width?: string;
	minWidth?: string;
	minHeight?: string;
	maxWidth?: string;
	children?: ReactNode;
	padding?: string;
	height?: string;
	flexWrap?: FlexWrap;
	className?: string;
	flex?: number;
	gap?: string;
	onClick?: () => any;
	backgroundColor?: string;
	bg?: string;
	cursor?: string;
	border?: string;
	borderRadius?: string;
	as?: any;
}

/**
 * @deprecated Use Flex component from @chakra-ui/react instead
 */
const Flex: React.FC<FlexProps> = ({
	direction: flexDirection,
	justifyContent: flexJustifyContent,
	alignItems: flexAlignItems,
	margin,
	width,
	minWidth,
	minHeight,
	maxWidth,
	padding,
	height,
	children,
	flexWrap,
	flex,
	gap,
	className,
	onClick,
	backgroundColor,
	bg,
	cursor,
	border,
	borderRadius,
	as,
	...rest
}) => {
	return (
		<FlexStyles
			direction={flexDirection}
			justifyContent={flexJustifyContent}
			alignItems={flexAlignItems}
			margin={margin}
			width={width}
			minWidth={minWidth}
			maxWidth={maxWidth}
			minHeight={minHeight}
			padding={padding}
			height={height}
			flexWrap={flexWrap}
			className={className}
			flex={flex}
			gap={gap}
			onClick={onClick}
			backgroundColor={backgroundColor || bg}
			cursor={cursor}
			border={border}
			borderRadius={borderRadius}
			as={as}
			{...rest}
		>
			{children}
		</FlexStyles>
	);
};

export default Flex;

const FlexStyles = styled.div<FlexProps>`
	display: flex;
	${(props) => (props.flex !== undefined ? `flex: ${props.flex};` : "")}
	flex-wrap: ${(props) => props.flexWrap};
	flex-direction: ${(props) => (props.direction ? props.direction : "row")};
	justify-content: ${(props) => (props.justifyContent ? props.justifyContent : "flex-start")};
	margin: ${(props) => props.margin};
	width: ${(props) => (props.width ? props.width : "100%")};
	${(props) => (props.minWidth ? `min-width: ${props.minWidth}` : "")};
	${(props) => (props.maxWidth ? `max-width: ${props.maxWidth}` : "")};
	${(props) => (props.minHeight ? `min-height: ${props.minHeight}` : "")};
	align-items: ${(props) => props.alignItems || ""};
	padding: ${(props) => props.padding};
	height: ${(props) => props.height};
	gap: ${(props) => props.gap};
	${(props) => (props.backgroundColor ? `background-color: ${props.backgroundColor}` : "")};
	${(props) => (props.cursor ? `cursor: ${props.cursor}` : "")};
	${(props) => (props.border ? `border: ${props.border}` : "")};
	${(props) => (props.borderRadius ? `border-radius: ${props.borderRadius}` : "")};
`;
